const importAll = (requireContext) =>
    requireContext
        .keys()
        .sort()
        .map((key) => {
            const asset = requireContext(key);
            return asset?.default ?? asset;
        });

export const episodeImages = {
    ep1: importAll(require.context("../assets/ep1.1", false, /\.(png|jpe?g|svg|webp)$/i)),
    ep2: importAll(require.context("../assets/ep2.1", false, /\.(png|jpe?g|svg|webp)$/i)),
    ep3: importAll(require.context("../assets/ep3.1", false, /\.(png|jpe?g|svg|webp)$/i)),
    ep4: importAll(require.context("../assets/ep4", false, /\.(png|jpe?g|svg|webp)$/i)),
    ep5: importAll(require.context("../assets/ep5.1", false, /\.(png|jpe?g|svg|webp)$/i)),
    ep6: importAll(require.context("../assets/ep6.1", false, /\.(png|jpe?g|svg|webp)$/i)),
    ep7: importAll(require.context("../assets/ep7.1", false, /\.(png|jpe?g|svg|webp)$/i)),
};

export default episodeImages;

